<footer class="edit-footer">
  <button
    *ngIf="cancelText"
    type="button"
    mat-button
    class="cancel"
    (click)="close()"
  >
    {{ cancelText }}
  </button>
  <button *ngIf="excuteText" mat-button class="excute" [disabled]="disabled">
    {{ excuteText }}
  </button>
</footer>
